import {
    Box,
    useColorModeValue,
    Tabs, TabList, TabPanels, Tab, TabPanel
} from '@chakra-ui/react'
import Layout from '../layout'
import ConfigurationForm from './ConfigurationForm'
import ConfigurationTerms from './ConfigurationTerms'
import ConfigurationPrivacy from './ConfigurationPrivacy'


const Configuration = () => {

    const color = useColorModeValue('white', 'gray.800')

    return (
        <Layout>
            <Box w={'full'} bg={color} rounded={'md'} m={3} p={6} >
                <Tabs>
                    <TabList>
                        <Tab>Configuracion General</Tab>
                        <Tab>Terminos y Condiciones</Tab>
                        <Tab>Aviso de privacidad</Tab>
                    </TabList>

                    <TabPanels >
                        <TabPanel>
                            <ConfigurationForm />
                        </TabPanel>

                        <TabPanel>
                            <ConfigurationTerms />
                        </TabPanel>

                        <TabPanel>
                            <ConfigurationPrivacy />
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Box>
        </Layout>
    )
}

export default Configuration
